import {useSelector} from 'react-redux';


export const useEnvironmentContext = (): {
  isExtension: boolean;
  isClientIframe: boolean;
  isSenseAiIframe: boolean;
  isTrmIframe: boolean;
  hasContextInUrl: boolean;
} => {
  // @ts-expect-error - TS2339 - Property 'env' does not exist on type 'DefaultRootState'.
  const {context} = useSelector((state) => state.env.query);
  const isExtension = context === 'chrome-extension';
  const isClientIframe = context === 'client-iframe';
  const isSenseAiIframe = context === 'sense-ai';
  const isTrmIframe = context === 'trm-iframe';
  const hasContextInUrl = context != null;

  return {
    isExtension,
    isClientIframe,
    isSenseAiIframe,
    isTrmIframe,
    hasContextInUrl,
  };
};
